import { SvgIcon } from '@/components/UI/Common/SvgIcon';
import { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { SearchInput } from '@/components/UI/Common/SearchInput';

const ChatsSearch = ({
  id = 'chats-search',
  className,
  onSearch,
  onFocus,
  onOpenChange,
}: {
  id?: string;
  className?: string;
  onSearch?: (value: string) => void;
  onFocus?: () => void;
  onOpenChange?: (isOpen: boolean) => void;
}) => {
  const [showSearch, setShowSearch] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!showSearch) return;
    inputRef.current?.focus();
  }, [showSearch]);

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  const setOpen = (isOpen: boolean) => {
    setShowSearch(isOpen);
    onOpenChange?.(isOpen);
  };

  const handleClose = () => {
    setOpen(false);
    onSearch?.('');
    if (inputRef.current) inputRef.current.value = '';
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      onSearch?.(value);
    }, 300);
  };

  return (
    <div
      id={id}
      className={cn(
        'flex gap-2.5 justify-end items-center min-w-0',
        showSearch ? 'flex-1 lg:flex-[2]' : 'shrink-0',
        className,
      )}
    >
      <div
        className={cn(
          'overflow-hidden transition-all duration-200 ease-out min-w-0',
          showSearch
            ? 'flex-1 opacity-100 translate-x-0'
            : 'max-w-0 w-0 opacity-0 -translate-x-2 pointer-events-none',
        )}
      >
        <SearchInput ref={inputRef} placeholder="Поиск" onChange={handleChange} onFocus={onFocus} />
      </div>
      <SvgIcon
        name="search"
        size={30}
        className="cursor-pointer shrink-0 md:scale-[0.8]"
        onClick={() => (showSearch ? handleClose() : setOpen(true))}
      />
    </div>
  );
};

export default ChatsSearch;
